<template>
  <div class='start-modal' ref="space">
    <!-- <img src='@/assets/images/ui/drag-to-move-black.png' />
    <p>Drag to move</p> -->
    <div class="modal-wrapper" ref="wrapper">
      <img
        class="cross"
        src="@/assets/images/ui/close.png"
        @click.prevent.stop='$emit("closeModal", false)'
      />
      <v-app class="carousel">
        <v-carousel
          v-model="activeStep"
        >
          <v-carousel-item
            v-for="(item, i) in items"
            :key="i"
          >
            <div class="content">
              <div :class="(item.images.length == 1) ? 'one-img-box' : 'two-img-box'">
                <v-row style="width: 100%">
                  <v-col
                    v-for="(image, i) in item.images" :key="i"
                    :cols="image.cols"
                  >
                    <v-img
                      :src="image.src"
                      :width="image.width ? image.width : '100%'"
                      :style="image.style"
                    />
                  </v-col>
                </v-row>
              </div>
              <div class="text-content text-h5">
                <p>{{ i+1 }}.</p>
                <p v-html="item.content"></p>
              </div>
              <div v-if="i === 0">
                <p class="text-dim">
                  <small>※ これはあくまで設計を補助するためのツールで、構造を担保するものではありません。</small>
                </p>
              </div>
              <div v-if="i === (items.length - 1)" class="bottom">
                <button
                  type="button"
                  name="button"
                  @click='$emit("closeModal", neverShowAgain)'
                >閉じる</button>
                <div class="input-box">
                  <input type="checkbox" name="check" value="noModal" v-model="neverShowAgain">
                  <label for="check">次回から表示しない</label>
                </div>
              </div>
            </div>
          </v-carousel-item>
        </v-carousel>
      </v-app>
    </div>
  </div>
</template>

<script>
import pngStep1 from '@/assets/images/howto/step1.png';
import pngStep2 from '@/assets/images/howto/step2.png';
import pngStep31 from '@/assets/images/howto/step3-1.png';
import pngStep32 from '@/assets/images/howto/step3-2.gif';
import pngStep4 from '@/assets/images/howto/step4.png';
import pngStep5 from '@/assets/images/howto/step5.png';

export default {
  components: {

  },

  data: () => ({
    activeStep: 0,
    items: [
      {
        images: [
          {
            src: pngStep1,
            cols: 12
          }
        ],
        content: 'このサイトでは各テンプレートデータを利用することで、<br>設計ツールをつかわなくてもデータの設計とEMARFの入稿ができます。'
      },
      {
        images: [
          {
            src: pngStep2,
            cols: 12
          }
        ],
        content: '左の「テンプレート」から好きなテンプレートを選択することができます。'
      },
      {
        images: [
          {
            src: pngStep31,
            cols: 4
          },
          {
            src: pngStep32,
            cols: 8,
            width: "89%",
            style: { marginLeft: "auto" }
          }
        ],
        content: 'テンプレートを選択後、右にあるパラメータを動かすないしは数値を入力して、好みのサイズ・形状にカスタマイズすることができます。'
      },
      {
        images: [
          {
            src: pngStep4,
            cols: 12
          }
        ],
        content: 'サイズ・形状が決まったら左下の「加工依頼」からデータを入稿することができます。'
      },
      {
        images: [
          {
            src: pngStep5,
            cols: 12
          }
        ],
        content: '入稿後に、材料の選択・配置の設定などを行うと見積が表示されるので、金額を確認して、加工依頼します。'
      }
    ],
    neverShowAgain: false
  }),

  props: {
    // userAgent: {
    //   type: String,
    //   default: ''
    // },
  },

  async mounted(){
    this.$refs.space.addEventListener("click", () => {
      this.$emit("closeModal", false);
    });
    this.$refs.wrapper.addEventListener("click", (e) => {
      e.stopPropagation();
    });

  },

  methods: {

  }
};

</script>

<style lang="scss" scoped>

.start-modal{
  width: 100vw;
  height: 100vh;

  display: flex;
  align-items: center;
  justify-content: center;

  position: absolute;
  z-index: 150;

  backdrop-filter: blur(3px);

  .modal-wrapper{
    width: 700px;
    height: 500px;
    background-color: rgba(0,0,0,0.6);
    border-radius: 15px;
    overflow: hidden;
    position: relative;

    .cross{
      position: absolute;
      width: 30px;
      height: 30px;
      z-index: 99;
      right: 20px;
      top: 20px;
      cursor: pointer;
    }

    .carousel{
      background: none;

      .content{
        background-color: none;
        height: calc(100% - 50px);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        margin-top: 3rem;
        position: relative;

        .one-img-box{
          position: relative;
          width: 80%;
          margin-bottom: 2rem;
          display: flex;

          img{
            width: 100%;
            height: auto;
          }
        }

        .two-img-box{
          position: relative;
          width: 80%;
          margin-bottom: 2rem;
          display: flex;
          justify-content: space-between;

          img{
            width: 45%;
            height: auto;
          }
        }

        .text-content{
          color: #fff;
          width: 80%;
          font-size: 18px !important;
          line-height: 2;
          display: flex;
          p{
            width: fit-content;
          }
          p:nth-child(1){
            margin-right: 1rem;
          }
        }

        .text-dim {
          color: #d0d0d0;
        }

        .bottom{
          position: absolute;
          color: #fff;
          bottom: 4rem;
          width: 80%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 14px;

          button{
            padding: 10px 20px;
            border-radius: 99em;
            background-color: #1bffc6;
            color: #000;
            font-weight: 700;
            line-height: 1;
          }

          .input-box{
            position: absolute;
            right: 0;
          }
        }
      }
    }

  }
}

</style>



// WEBPACK FOOTER //
// src/components/viewer/StartModal.vue